import { useParams } from "react-router-dom";
import { JobPostsV2 as JobPostsV2Component } from "../components/job-iframe/JobPostsV2";
import PageNotFound from "./PageNotFound";

const JobPostsV2 = () => {
  const { organizationId, id } = useParams();

  if (!organizationId || !id) {
    return <PageNotFound />;
  }

  return <JobPostsV2Component organizationId={organizationId} id={id} />;
};

export default JobPostsV2;
